<template>
    <div>
        <breadcrumb :routerList="[{to:'/dingd/dingdmainlist',title:'订单管理'},{title:'创建订单'}]"/>

        <div class="h-piece ddform_disable_cls">
            <div class="h-pieceIn2">
                <div class="h-pieceTitle2" style="margin-left:10px">
                    <h1>发货信息</h1>
                </div>
                <div class="h-pieceCon2">
                    <div class="h-formLine n-two">
                        <el-form label-position="right" :inline="true" ref="form1" :model="order"
                                 class="demo-ruleForm h-formbLine">
                            <el-form-item label="发货单号" class="h-elformWrap-2">
                                <el-input  v-model="order.id" disabled=""></el-input>
                            </el-form-item>
                            <el-form-item label="备件数量" class="h-elformWrap-2" prop="count">
                                <el-input  v-model="order.count"></el-input>
                            </el-form-item>
                            <el-form-item label="备件体积" class="h-elformWrap-2" prop="count">
                                <el-input  v-model="order.bjtj" ></el-input>
                            </el-form-item>
                            <el-form-item label="要求送货时间" class="h-elformWrap-2" prop="requiredDeliveryTime">
                                <el-date-picker v-model="order.requiredDeliveryTime" type="datetime" :clearable="false"
                                                class="h-tableInput"
                                                value-format="yyyy-MM-dd HH:mm" :placeholder="order.requiredDeliveryTime"
                                                placeholder="请选择日期" :picker-options="pickerOptions">
                                </el-date-picker>
                            </el-form-item>
                            <!--<el-form-item label="是否有f唛头" class="h-elformWrap-2">-->
                                <!--<el-select placeholder="请选择" style="width:100%" v-model="order.marks" disabled="">-->
                                    <!--<el-option label="否" :value="0"></el-option>-->
                                    <!--<el-option label="是" :value="1"></el-option>-->
                                <!--</el-select>-->
                            <!--</el-form-item>-->
                            <el-form-item label="送货方式" class="h-elformWrap-2">
                                <el-select placeholder="请选择" style="width:100%" v-model="order.fhWay">
                                    <el-option label="拼箱" value="1"></el-option>
                                    <el-option label="整柜" value="2"></el-option>
                                    <el-option label="快递" value="3"></el-option>
                                    <el-option label="自提" value="4"></el-option>
                                    <el-option label="空运" value="5"></el-option>
                                    <el-option label="异地" value="6"></el-option>
                                    <el-option label="直发" value="7"></el-option>
                                </el-select>
                            </el-form-item>
                            <!--<el-form-item label="唛头格式上传" class="h-elformWrap-2" v-if="order.marks=='1'">-->
                                <!--<brupload-->
                                        <!--disabled=""-->
                                        <!--:refid=order.id-->
                                        <!--reftype="订单-发货计划-M"-->
                                        <!--:limit="1"-->
                                        <!--:showtime="false"-->
                                        <!--uploadflag-->
                                        <!--delflag-->
                                <!--&gt;-->
                                <!--</brupload>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="拼箱信息表" class="h-elformWrap-2" v-if="order.ztype =='LCL'">-->
                                <!--<brupload-->
                                        <!--disabled=""-->
                                        <!--:refid=order.id-->
                                        <!--reftype="订单-发货计划-P"-->
                                        <!--:limit="1"-->
                                        <!--:showtime="false"-->
                                        <!--uploadflag-->
                                        <!--delflag-->
                                <!--&gt;-->
                                <!--</brupload>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="装箱图" class="h-elformWrap-2"  v-if="order.ztype =='FCL'">-->
                                <!--<brupload-->
                                        <!--disabled=""-->
                                        <!--:refid=order.id-->
                                        <!--reftype="订单-发货计划-Z"-->
                                        <!--:limit="1"-->
                                        <!--:showtime="false"-->
                                        <!--uploadflag-->
                                        <!--delflag-->
                                <!--&gt;-->
                                <!--</brupload>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="件重尺" class="h-elformWrap-2" v-if="order.ztype =='FCL'">-->
                                <!--<el-input-->
                                        <!--disabled=""-->
                                        <!--style="width: 100%;margin-top: 0.1rem;"-->
                                        <!--type="textarea"-->
                                        <!--placeholder="请输入"-->
                                        <!--v-model="order.numWeightSize">-->
                                <!--</el-input>-->
                            <!--</el-form-item>-->
                            <!--<el-form-item label="入货通知上传" class="h-elformWrap-2">-->
                                <!--<brupload-->
                                        <!--disabled=""-->
                                        <!--:refid=order.id-->
                                        <!--reftype="订单-发货计划-R"-->
                                        <!--:limit="1"-->
                                        <!--:showtime="false"-->
                                        <!--uploadflag-->
                                        <!--delflag-->
                                <!--&gt;-->
                                <!--</brupload>-->
                            <!--</el-form-item>-->
                        </el-form>
                    </div>
                </div>
            </div>
            <!-------------------------------------------------------订单信息-------------------------------------------------------------------->

            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->
            <div class="h-table h-mrt30 ljjtablepaddings3" style="margin: -20px 20px 0 20px;">
                <div class="h-pieceTitle2 message">
                    <h1 class="h1">订单信息</h1>
                </div>
                <div class="h-piece h-mrt30 margin">
                    <div class="h-formBox">
                        <el-form :inline="true" :model="formInline" class="demo-form-inline h-formBorder" ref="form">
                            <div class="h-thirdColumn w-newColumn">
                                <el-form-item label="订单编号" prop="sapCode" style="width: 50%;">
                                    <el-input v-model="formInline.sapCode" placeholder="多订单模糊查询请用空格或分号分隔"></el-input>
                                </el-form-item>
                            </div>
                        </el-form>
                        <div class="l-screenBox">
                            <div class="l-retrieval">
                                <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                                <el-button class="h-btn h-formBtn h-bgwhite" @click="resetData">重置</el-button>
                            </div>
                        </div>
                    </div>
                </div>
                <el-table
                        ref="multipleTable"
                        :data="productlist1"
                        stripe
                        border
                        style="width: 100%">
                    <el-table-column
                            type="index"
                            fixed
                            label="#"
                            width="40">
                    </el-table-column>
                    <el-table-column
                            prop="sapCode"
                            label="订单号"
                            width="150" >
                    </el-table-column>
                    <el-table-column
                            prop="ycid"
                            label="预测单号"
                            width="150" >
                    </el-table-column>
                    <el-table-column
                            prop="ycrname"
                            label="预测人"
                            min-width="120"
                            :show-overflow-tooltip="true" >
                        <template slot-scope="scope">
                            {{ scope.row.ycrname }} {{ scope.row.ycrcode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="ycrCountry"
                            label="预测单国家"
                            min-width="120"
                            :show-overflow-tooltip="true" >
                    </el-table-column>
                    <el-table-column
                            prop="proModelName"
                            label="产品大类"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="materialCode"
                            label="产品编码"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="materialName"
                            label="产品名称"
                            :show-overflow-tooltip="true"
                            width="180">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.materialName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="proType"
                            label="产品属性"
                            :show-overflow-tooltip="true"
                            width="80">
                        <template scope="scope">
                            <div>
                                <span v-if="scope.row.proType == '1'">OEM</span>
                                <span v-else-if="scope.row.proType == '0'">自产</span>
                                <span v-else>{{scope.row.proType}}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="proNumber"
                            label="数量"
                            :show-overflow-tooltip="true"
                            width="60">
                        <template scope="scope">
                            <div style="text-align: right;">
                                {{scope.row.proNumber}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="soldToCode"
                            label="售达方编码"
                            :show-overflow-tooltip="true"
                            width="110">
                    </el-table-column>
                    <el-table-column
                            prop="soldToName"
                            label="售达方名称"
                            :show-overflow-tooltip="true"
                            min-width="180">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.soldToName}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="add3"
                            label="交货单号"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="add2"
                            label="SO单号"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="isCustommed"
                            label="常规或改制"
                            :show-overflow-tooltip="true"
                            width="110">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isCustommed == 0">
                                常规
                            </div>
                            <div v-else>
                                改制
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="specificReform"
                            label="改制要求"
                            :show-overflow-tooltip="true"
                            width="180">
                        <template scope="scope">
                            <div style="text-align: left;">
                                {{scope.row.specificReform}}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column
                            prop="currencyCode"
                            label="币种"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="totalprice"
                            label="总价"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="hjtiji"
                            label="总立方数"
                            width="120"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                        prop="scDateB"
                        label="生产日期"
                        width="100"
                        :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column
                            prop="note"
                            label="备注"
                            width="150"
                            :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                    <el-button
                    type="text"
                    size="small"
                    class="h-tableLink h-btn"
                    @click="deleteThis(scope.row)">
                    删除
                    </el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </div>
            <!-------------------------------------------------------产品信息-------------------------------------------------------------------->


            <!--------------------------------------------------------------------收货地址弹出框-------------------------------------------------------->
            <!--物料-->
           <!-- <waixiaowxwl :visible.sync="showwuliaodialog1"
                         v-if="showwuliaodialog1"
                         @choseObj="choseWuliao1"
                         title="选择预测单"/>-->
        </div>
        <div>
            <div class="anniu">
                <el-button class="h-btn h-bBtn h-bgwhite"  @click="backtolist">返回</el-button>
                <!--<el-button class="h-btn h-bBtn h-bggreen" @click="saveOrSubmit(10)">暂存</el-button>-->
                <el-button class="h-btn h-bBtn h-bgblueQ2" @click="saveOrSubmit()">确认提交</el-button>
            </div>
        </div>
    </div>
</template>

<script>
    import big from 'big.js'
    import ss from '../../api/SystemService'
    //import waixiaowxwl from '../../components/dialog/wxwl-dingdan'
    import shoudf from '../../components/dialog/selectshdf'

    export default {
        components: {
             shoudf
        },
        data() {
            return {
                submitChongfuFlag:true,
                //有国家大区的国家
                QYcountryList:[],
                areaList:[],
                areaUserList:[],
                costList:[],

                showIsFree:false,

                resubmit:false,
                instid:null,
                taskstatus:0,

                showhistory:false,

                selectDailishang:true,


                showwuliaodialog1:false,
                showwuliaodialog2:false,
                showshdfdialog:false,
                showdizhiflag:false,
                currentUser:null,
                showaddProductRow:true,
                showFee:true,

                //showdelProductRow: true,

                //是否需要信贷
                needxindai:true,
                needxinjin:true,
                //付款方式，不需要信贷
                fjksnotjy:['HT02','LC50'],
                //上传信用证
                shifouxinyzh:false,
                //特价
                tejieshowflag:false,
                //定制展示
                dingzhishowflag:false,

                //单位
                dwzhiliang:null,
                dwtiji:null,
                //现金余额
                cashBalance:0,
                //项目编码
                xmcode:null,
                ddlx:null,
                // 限制收货时间不让选择今天以前的
                pickerOptions: {
                    disabledDate(time) {
                        return time.getTime() < Date.now() - 24 * 60 * 60 * 1000
                    }
                },
                order:{
                    fhWay:null,
                    bjtj:null,
                    numWeightSize:null,
                    marks:null,
                    id:null,
                    shipDate:null,
                    despatchOrderTime:null,
                    shipmentUnit:null,
                    afterSalesNetwork:null,
                    requiredDeliveryTime:this.dateFormatter(new Date(),false),
                    country:null,
                    sparePart:null,
                    count:null,
                    ztype:null
                },
                //表单
                formInline: {
                    pageSize: 10,
                    pageNo: 1,
                    total: 0,
                    sapCode:"",
                    orderTypebz: 2,
                    orderCategory: "2",
                },
                //产品list
                productlist1:[],

                //用户信贷list
                creditData:[],
                disabled:false,
                id:null
            }
        },
        //页面加载前事件
        created() {
            this.id = this.$route.query.id;
            this.showQycountry();
        },
        mounted(){

        },
        computed:{

        },
        watch:{
        },
        methods: {
            dateFormatter(str){//默认返回yyyy-MM-dd HH-mm-ss
                var hasTime = arguments[1] != false ? true : false;//可传第二个参数false，返回yyyy-MM-dd
                var d = new Date(str);
                var year = d.getFullYear();
                var month = (d.getMonth()+1)<10 ? '0'+(d.getMonth()+1) : (d.getMonth()+1);
                var day = d.getDate()<10 ? '0'+d.getDate() : d.getDate();
                var hour = d.getHours()<10 ? '0'+d.getHours() : d.getHours();
                var minute = d.getMinutes()<10 ? '0'+d.getMinutes() : d.getMinutes();
                var second = d.getSeconds()<10 ? '0'+d.getSeconds() : d.getSeconds();
                console.log("日期",hour)
                return [year, month, day].join('-') + " " + [15, "0"+"0"].join(':');
            },
            keyupEvent(e,input){
                e.target.value=e.target.value.replace(/[^\d.]/g, '');
                e.target.value=e.target.value.replace(/\.{2,}/g, '.');
                e.target.value=e.target.value.replace(/^\./g, '0.');
                e.target.value=e.target.value.replace(/^\d*\.\d*\./g, e.target.value.substring(0,e.target.value.length-1));
                e.target.value=e.target.value.replace(/^0[^\.]+/g, '0')
                e.target.value=e.target.value.replace(/^(\d+)\.(\d\d).*$/, '$1.$2')
                this.input=e.target.value
            },
            viewpress(r){
                this.showhistory = true;
            },
            backtolist(){
                this.$router.go(-1);
            },
            saveOrSubmit(v){
                this.order.orderNum = this.productlist1.join(',');
                let id = [];
                this.productlist1.forEach((item)=>{
                    id.push(item.sapCode);
                })
                this.order.orderNum = id.join(",")
                this.order.country = this.productlist1[0].shipToAreaCode
                this.$refs['form1'].validate((valid1) => {
                    if (valid1) {
                        this.$msg.confirm("确认提交？",()=>{
                            this.submitForm();
                        })
                    }else{
                        this.$msg.msge("请完善基本信息后提交");
                        return;
                    }
                });
            },
            submitForm(){
                this.submitChongfuFlag = false;
                ss.OrderMainService.updateShipmentSchedule(this.order).then(rd=>{
                    this.submitChongfuFlag = true;
                    if(rd.f) {
                        this.$msg.msgs("提交成功！")
                        this.$router.push({path: '/dingd/deliveryPlanList'})
                    }else{
                        this.$msg.msge(rd.msg);
                    }
                })
            },
            //删除该行项目产品信息
            deleteThis(x) {
                this.$msg.confirm("确认删除？",()=>{
                    this.productlist1 = _.reject(this.productlist1, {'sapCode': x.sapCode});
                    ss.OrderMainService.delShipmentSchedule(x.sapCode).then(rd=>{

                    })
                })
            },

            //选择物料
            showProcuct1() {
                this.showwuliaodialog1 = true;
            },
            //选择物料
            choseWuliao1(objs) {
                objs.forEach((item,index) => {
                    this.productlist1.push(item);
                });
                this.showwuliaodialog1 = false;
            },
            //有国家大区的送达方
            showQycountry(){
                ss.OrderMainService.showQycountry().then(rd=>{
                    this.QYcountryList = rd;
                })
                this.createShipmentNum();
            },
            //发货单号
            createShipmentNum(){
                ss.OrderMainService.selectShipmentInfo(this.id).then(rd=>{
                    // this.order.id = rd;
                    this.order = rd;
                    this.querypage();
                })
            },
            querypage(p){
                var data = {}
                data.orderNum = this.order.orderNum
                ss.wuliaoselect.checkOrderInfo(data).then(rd=>{
                    this.productlist1 = rd;
                })
            },
            query() {
                ss.wuliaoselect.selectFhPage(this.formInline).then(rd => {
                    this.productlist1 = rd;
                    //console.log('tableData', this.tableData);
                    // this.formInline.total = rd.total || 0;
                });
            },
            //检索
            handleFilter() {
                this.formInline.pageNo = 1;
                this.query();
            },
            // 重置按钮
            resetData() {
                this.formInline.sapCode = null;
                this.query();
            },
        }
    }

</script>


<style scoped>
    .queren {
        background-color: #006aca;
        color: white;
    }

    .anniu {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .zancun {
        background-color: #24b5b8;
        color: white;
    }

    .quxiao, .zancun {

        width: 100px;
    }
    .jieguo {
        border-bottom: 1px solid rgb(238, 236, 236);
        display: flex;
    }
    .jieguo .jieguo_label{
        width: 2rem;
        text-align: right;
        background-color: #ebf5ff;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0 0.05rem;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .jieguo .jieguo_value{
        width: 20%;
        font-size: 0.16rem;
        color: #616467;
        height: 0.4rem;
        line-height: 0.4rem;
        padding: 0px 8px;
    }
    img {
        width: 25px;
        padding: 5px 0;
        margin-left: 8rem;
    }

    .newProject {
        margin: 0 20px;
        background-color: rgb(94, 182, 233);
    }
    .h-piece {
        margin: 20px;
    }
    .DshuR {
        width: 100%;
        height: 100%;
        border: none;
    }


    .message {
        padding: 20px 0;
        margin-bottom: 0;
        background-color: white;
    }

    .n-xiao .h-formbLine .h-elformWrap-2,
    .n-two .h-formbLine .h-elformWrap-2 {
        width: 33.333%;
    }

    .el-cascader {
        line-height: normal;
    }
</style>
<style>
    .n-two .h-formbLine .el-form-item__content .el-select,
    .n-two .el-form .h-formbLine .el-form-item__content .el-select {
        width: 0;
    }

    .n-xiao .h-formbLine .el-form-item__label,
    .n-two .h-formbLine .el-form-item__label {
        width: 43%;
    }

    .n-xiao .h-formbLine .el-form-item__content,
    .n-two .h-formbLine .el-form-item__content {
        width: 57%;
    }


    /* .el-table__header .el-table-column--selection .cell .el-checkbox::after {
        content: "全选";
        color: white;
        background-color: rgb(93, 172, 236);
        font-size: 10px;
    } */
    .ljjtablepaddings3 .h-tableInput .el-input__inner{
        padding: 0.05rem 0.1rem;
    }
    .ljjtablepaddings3 .h-tableInput .el-input__icon{
        line-height: 0.25rem;
    }
    .ljjtablepaddings3 .ljjsales .el-input__inner{
        height: 0.3rem;
    }
    .ljjtablepaddings3 .ljjsales .el-input__icon{
        line-height: 0.42rem;
    }
</style>

<style scoped lang="scss">
    .areaSelect {
        position: fixed;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.6);
        top: 0;
        left: 0;
        z-index: 2019;

        .centerBlock {
            width: 700px;
            height: 400px;
            padding: 20px;
            border-radius: 20px;
            background-color: white;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
        }
    }
    .dingzhicss{
        font-size: 12px;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
</style>
<style>
    .aaa .el-dialog__headerbtn {
        display: none;
    }
    .ddform_disable_cls .el-form-item__content .el-input__inner[disabled] {
        color: #868686;
    }
</style>
